import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AOS from 'aos'; // Importar AOS
import 'aos/dist/aos.css'; // Importar estilos de AOS
import Navbar from './components/Navbar';
import Footer from './components/footer';
import FloatingButton from './components/FloatingButton';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './assets/styles/App.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import ScrollToTop from './components/ScrollToTop';

const App = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000, 
      easing: 'ease-in-out', 
      once: false, 
      mirror: true,
    });

    // Refrescar AOS en caso de cambios dinámicos en el DOM
    AOS.refresh();
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <FloatingButton />
      <Footer />
    </Router>
  );
};

export default App;


